import { useSelector } from '@xstate/react';
import { useCallback, useState } from 'react';

import { Checkbox } from '@webapp/common/components/checkbox';
import { useTextStyle } from '@webapp/common/components/custom-styles';
import { CssQuestionType } from '@webapp/common/components/survey-custom';
import { InputCounter, Textfield } from '@webapp/common/components/textfield';
import { CANTRATE_ID } from '@webapp/common/resources/constants';

import type { SurveyQuestion } from '@webapp/survey/src/components/questions/lib';
import { selectIsWithAudioRecogn } from '@webapp/survey/src/machine/selectors';
import { useStateSelector } from '@webapp/survey/src/machine/use-state-selector';

const style = { width: '100%' };

export const ShortText: FC<SurveyQuestion> = ({
    question: {
        responseActor,
        id,
        params: { cantRate, cantRateText, minLength = 0, maxLength, placeholder },
    },
}) => {
    const isWithAudioRecogn = useStateSelector(selectIsWithAudioRecogn);
    const { value } = useSelector(responseActor, (r) => r.context);
    const { inputStyle } = useTextStyle();

    const [cantRateChecked, setCantRateChecked] = useState<boolean>(value === CANTRATE_ID);

    const change = useCallback(
        (value) => {
            setCantRateChecked(false);
            responseActor.send({ type: 'CHANGE', value, questionId: id });
        },
        [responseActor],
    );

    const handleCantRate = useCallback(
        (checked: boolean) => {
            setCantRateChecked(checked);
            responseActor.send({ type: 'CHANGE', value: checked ? CANTRATE_ID : '', questionId: id });
        },
        [responseActor, id],
    );

    return (
        <div className={CssQuestionType.SHORT_TEXT} style={style}>
            <Textfield
                withSpeechRecognition={isWithAudioRecogn}
                transparent
                style={inputStyle}
                value={cantRateChecked ? '' : (value as string) || ''}
                onChange={change}
                maxLength={maxLength}
                placeholder={placeholder}
            />
            {(minLength >= 0 || maxLength > 0) && (
                <InputCounter min={minLength} max={maxLength} currentLength={value ? String(value).length : 0} />
            )}
            {cantRate && (
                <div style={{ marginTop: '10px' }}>
                    <Checkbox checked={cantRateChecked} label={cantRateText} onChange={handleCantRate} />
                </div>
            )}
        </div>
    );
};
ShortText.displayName = 'ShortText';
